import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/auth/actions";
import { useEffect, useRef, useState } from "react";
import storePersist from "../../redux/storePersist";
import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import { selectListItems } from "../../redux/organizationUnits/selector";

const Sidebar = () => {
  let items: any = []
	let subitems: any = []
	let menuitems: any = []
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
	const result = useSelector(selectCurrent)
  const [logo, setLogo] = useState<any>()
  const [color, setColor] = useState('universal')
  const { header, footer, visible, sidebar,theme,primary ,secondary} = result
	const [activeIndex, setActiveIndex] = useState(null);
	const [activeSubIndex, setActiveSubIndex] = useState(null);
  const { height, width } = useWindowDimensions();
  const organizationLists= useSelector(selectListItems)
  const dropdownRef = useRef<HTMLDivElement>(null);
	const [menus, setMenus] = useState([
		
      {
        id: `main-menu-2-all`,
        path: '/digiit-ai/purchase-programs',
        label: 'Purchase Programs',
        isEnabled:true,
        svg:(
          <svg className="h-7 w-7 text-white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF">
  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
  <g id="SVGRepo_iconCarrier">
    <title></title>
    <g id="Card">
      <path  d="M21,17H20V12a1,1,0,0,0-1-1H13V7h1a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H10A1,1,0,0,0,9,3V6a1,1,0,0,0,1,1h1v4H5a1,1,0,0,0-1,1v5H3a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H7a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H6V13h5v4H10a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H13V13h5v4H17a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18A1,1,0,0,0,21,17ZM11,4h2V5H11ZM6,20H4V19H6Zm7,0H11V19h2Zm7,0H18V19h2Z"></path>
    </g>
  </g>
</svg>
  
        ),
        
        Description:'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
        subMenu: [
          
        ],
      },

      {
		id: `main-menu-2-all`,
		path: '/digiit-ai/subscriptions',
		label: 'Subscriptions',
		isEnabled:true,
		svg:(
		  <svg className="h-7 w-7 text-white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF">
  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
  <g id="SVGRepo_iconCarrier">
	<title></title>
	<g id="Card">
	  <path  d="M21,17H20V12a1,1,0,0,0-1-1H13V7h1a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H10A1,1,0,0,0,9,3V6a1,1,0,0,0,1,1h1v4H5a1,1,0,0,0-1,1v5H3a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H7a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H6V13h5v4H10a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H13V13h5v4H17a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18A1,1,0,0,0,21,17ZM11,4h2V5H11ZM6,20H4V19H6Zm7,0H11V19h2Zm7,0H18V19h2Z"></path>
	</g>
  </g>
  </svg>
  
		),
		
		Description:'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
		subMenu: [
		  
		],
	  },

	  {
		id: `main-menu-2-all`,
		path: '/digiit-ai/billing-info',
		label: 'Billing',
		isEnabled:true,
		svg:(
		  <svg className="h-7 w-7 text-white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF">
  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
  <g id="SVGRepo_iconCarrier">
	<title></title>
	<g id="Card">
	  <path  d="M21,17H20V12a1,1,0,0,0-1-1H13V7h1a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H10A1,1,0,0,0,9,3V6a1,1,0,0,0,1,1h1v4H5a1,1,0,0,0-1,1v5H3a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H7a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H6V13h5v4H10a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H13V13h5v4H17a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18A1,1,0,0,0,21,17ZM11,4h2V5H11ZM6,20H4V19H6Zm7,0H11V19h2Zm7,0H18V19h2Z"></path>
	</g>
  </g>
  </svg>
  
		),
		
		Description:'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
		subMenu: [
		  
		],
	  },
     
	])

  const [open, setOpen] = useState(items)
	const [isMore, setIsMore] = useState(false)
	const [subOpen, setSubOpen] = useState(subitems)
	const [menuOpen, setMenuOpen] = useState(menuitems)
	menus.map((item) => {
		items.push({ open: true, isActive: false })
		
	  })
	
	
	  const handleClickOutside = (event: MouseEvent) => {
		if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
		  let menu = [...open]
		  open?.map((obj: any, idx: any) => {
			// menu[idx].isActive = false
			menu[idx].open = true
		  })
		  setOpen(menu)
		  let menu1 = [...subOpen]
		  subOpen?.map((obj: any, idx: any) => {
			// menu1[idx].isActive = false
			menu1[idx].open = true
		  })
		  setSubOpen(menu1)
		  let menu2 = [...menuitems]
		  menuitems?.map((obj: any, idx: any) => {
			// menu2[idx].isActive = false
			menu2[idx].open = true
		  })
		  setMenuOpen(menu2)
		}
	  };
	const handleItemClick = (index:any) => {
		setActiveIndex(index === activeIndex ? null : index);
	  };
	  const handleSubItemClick = (index:any) => {
		setActiveSubIndex(index === activeSubIndex ? null : index);
	  };

    const handleSideBarView = () => {
      dispatch(settings.set({ sidebar: !sidebar }))
    }
  	const fetchLogo =()=>{

      const storeData = {
        logoDark : organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
        return logo.Background === 'Light'
          }),
         logoLight:  organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
          return logo.Background === 'Dark'
            }),
         storeName:  organizationLists?.result?.items[0]?.BrandMappings[0]?.Name,
         description:  organizationLists?.result?.items[0]?.BrandMappings[0]?.Description,
         favicon: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Favicons[0]?.Url || '/assets/img/logo.png'
        }
        setLogo(storeData)
    }
    useEffect(() => {
      if (storePersist?.get("organizationUnits")?.isSuccess) {
        fetchLogo()
      }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
     
    }, [])
  
    const handleNavigate = (data: any) => {
      navigate(`${data}`)
    }
  
    const handleMenu = (index: any, index1: any) => {
      let menu = [...open]
      open?.map((obj: any, idx: any) => {
        if (idx == index) {
          menu[idx].open = !obj.open
          menu[idx].isActive = true
        }
        else {
          menu[idx].open = true
          menu[idx].isActive = false
        }
      })
      setOpen(menu)
    }
    const handleSubMenu = (e: any, index: any) => {
      e.stopPropagation()
      let menu = [...subOpen]
      subOpen?.map((obj: any, idx: any) => {
        if (idx == index) {
          menu[idx].open = !obj.open
          menu[idx].isActive = true
        }
        else {
          menu[idx].open = true
          menu[idx].isActive = false
        }
      })
      setSubOpen(menu)
    }
    const handleItems = (e: any, itemIndex: any) => {
      e.stopPropagation()
      let menu2 = [...menuitems]
      menuitems?.map((obj: any, idx: any) => {
        if (idx == itemIndex) {
          menu2[idx].isActive = true
          menu2[idx].open = !obj.open
        }
        else {
          menu2[idx].isActive = false
          menu2[idx].open = true
        }
      })
      setMenuOpen(menu2)
    }
  
    const beginWord = (sentence: string | undefined | null) => {
      if (!sentence || typeof sentence !== 'string') {
        return '';
      }
      const words = sentence.trim().split(/\s+/);
      if (words.length === 0) {
        return '';
      }
      if (sentence.length > 19) {
        const lastWord = words.pop() as string;
        let transformedSentence = ""
        if (words.length == 1) {
          transformedSentence = `${words[0]} `;
        }
        else if (words.length == 2)
          transformedSentence = `${words[0]} ${words[1]}`;
        return transformedSentence
      }
      else {
        return sentence
      }
    }
  
    const endWord = (sentence: string | undefined | null) => {
      if (!sentence || typeof sentence !== 'string') {
        return '';
      }
      const words = sentence.trim().split(/\s+/);
      if (words.length === 0) {
        return '';
      }
      if (sentence.length > 19) {
        const lastWord = words.pop() as string;
        return lastWord
      }
    }
  
    return (
      <>
        {sidebar ?     <div className={`w-64 fixed md:top-0 md:left-0 h-screen lg:block primary-${color} z-10 `}>
  
          {sidebar &&
            <div className={`w-full flex flex-col justify-end items-end p-2 pr-4 mt-20 lg:mt-20 md:mt-20`}>
              <svg
                onClick={() => dispatch(settings.set({ sidebar: !sidebar }))}
                width="22" height="22" viewBox="0 0 24 24" fill="none" className="cursor-pointer hover:stroke-hilight">
                  <title>Show Less Infomation</title>
                <path stroke-width="1.25" d="M12.6772 19.5377C12.9742 19.8265 13.449 19.8198 13.7377 19.5228C14.0265 19.2258 14.0198 18.751 13.7228 18.4623L12.6772 19.5377ZM6 12L5.47719 11.4623C5.33195 11.6035 5.25 11.7974 5.25 12C5.25 12.2026 5.33195 12.3965 5.47719 12.5377L6 12ZM13.7228 5.53775C14.0198 5.24901 14.0265 4.77418 13.7377 4.47719C13.449 4.1802 12.9742 4.17351 12.6772 4.46225L13.7228 5.53775ZM17.4772 18.3708C17.7742 18.6595 18.249 18.6528 18.5378 18.3558C18.8265 18.0588 18.8198 17.584 18.5228 17.2952L17.4772 18.3708ZM12 12L11.4772 11.4622C11.332 11.6035 11.25 11.7974 11.25 12C11.25 12.2026 11.332 12.3965 11.4772 12.5378L12 12ZM18.5228 6.70476C18.8198 6.41603 18.8265 5.9412 18.5378 5.64421C18.249 5.34721 17.7742 5.34051 17.4772 5.62924L18.5228 6.70476ZM13.7228 18.4623L6.52281 11.4623L5.47719 12.5377L12.6772 19.5377L13.7228 18.4623ZM6.52281 12.5377L13.7228 5.53775L12.6772 4.46225L5.47719 11.4623L6.52281 12.5377ZM18.5228 17.2952L12.5228 11.4622L11.4772 12.5378L17.4772 18.3708L18.5228 17.2952ZM12.5228 12.5378L18.5228 6.70476L17.4772 5.62924L11.4772 11.4622L12.5228 12.5378Z" fill="#f8f8f8" />
              </svg>
            </div>
          }
          <div className="h-[calc(100vh-10rem)] overflow-auto">
            <div className="mb-4  px-4 h-max ">
              {menus.map((obj: any, index1: any) => {
                return <li
                  onClick={() => handleMenu(index1, null)}
                  className={`w-full flex flex-col justify-start space-y-3 `}>
                  <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary  dark:hover:text-black" ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} `}>
                    {obj?.svg}
                    <span onClick={() => handleNavigate(obj?.path)} className="dark:hover:text-black w-36 text-sm ">{obj.label}</span>
                  </div>
                  {obj?.subMenu?.map((obj1: any, index2: any) => {
                    return <ul
                      onClick={(e) => handleSubMenu(e, index2)}
                      className={`w-full flex pl-2 flex-col justify-center space-y-3 ${open[index1]?.open ? 'hidden' : 'ml-2'} `}>
                      <div className={`flex flex-row justify-start  items-center  rounded-r-lg  px-2 cursor-pointer  h-10 hover:bg-secondary dark:hover:text-black"  ${subOpen[index2]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                        {obj1?.svg}
                        <div onClick={() => handleNavigate(obj1?.path)} className="primary-${color}  text-sm dark:text-slate-200 dark:hover:text-black w-36  flex flex-col w-auto justify-center items-end">
                          <span className="">{beginWord(obj1.label)}</span>
                          <span className="text-right text-xs italic">{endWord(obj1.label)}</span>
                        </div>
                      </div>
                      {obj1?.subMenu?.map((obj2: any, index3: any) => {
                        return <li
                          onClick={(e) => handleItems(e, index3)}
                          className={`w-full flex flex-col pl-2 justify-start space-y-3  ${subOpen[index2]?.open ? 'hidden' : 'ml-2'} `}>
                          <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary dark:hover:text-black"  ${menuOpen[index3]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                            {obj2?.svg}
                            <div onClick={() => handleNavigate(obj2?.path)} className="text-sm dark:text-slate-200 dark:hover:text-black w-36 flex flex-col w-auto justify-center items-end">
                              <span className="">{beginWord(obj2.label)}</span>
                              <span className="text-right text-xs italic"> {endWord(obj2.label)}</span>
                            </div>
                          </div>
                        </li>
                      })}
                    </ul>
                  })}
                </li>
              })}
            </div>
          </div>
          </div> : <div ref={dropdownRef} className={`w-24 fixed md:top-0 md:left-0 h-screen lg:block primary-${color} z-10`} >
          <div className="">
            {!sidebar &&
              <div className={`w-full flex flex-col justify-end items-end p-2 mt-20 lg:mt-20 md:mt-20`}>
                <svg
                  onClick={() => dispatch(settings.set({ sidebar: !sidebar }))}
                  width="22" height="22" viewBox="0 0 24 24" fill="none" className="cursor-pointer hover:stroke-hilight">
                    <title>Show More Infomation</title>
                  <path stroke-width="1.25" d="M10.2772 18.4623C9.9802 18.751 9.97351 19.2258 10.2623 19.5228C10.551 19.8198 11.0258 19.8265 11.3228 19.5377L10.2772 18.4623ZM18 12L18.5228 12.5377C18.6681 12.3965 18.75 12.2026 18.75 12C18.75 11.7974 18.6681 11.6035 18.5228 11.4623L18 12ZM11.3228 4.46225C11.0258 4.17351 10.551 4.1802 10.2623 4.47719C9.97351 4.77418 9.9802 5.24901 10.2772 5.53775L11.3228 4.46225ZM5.47721 17.2952C5.18021 17.584 5.17351 18.0588 5.46224 18.3558C5.75097 18.6528 6.2258 18.6595 6.52279 18.3708L5.47721 17.2952ZM12 12L12.5228 12.5378C12.668 12.3965 12.75 12.2026 12.75 12C12.75 11.7974 12.668 11.6035 12.5228 11.4622L12 12ZM6.52279 5.62924C6.2258 5.34051 5.75097 5.34721 5.46224 5.64421C5.17351 5.9412 5.18021 6.41603 5.47721 6.70476L6.52279 5.62924ZM11.3228 19.5377L18.5228 12.5377L17.4772 11.4623L10.2772 18.4623L11.3228 19.5377ZM18.5228 11.4623L11.3228 4.46225L10.2772 5.53775L17.4772 12.5377L18.5228 11.4623ZM6.52279 18.3708L12.5228 12.5378L11.4772 11.4622L5.47721 17.2952L6.52279 18.3708ZM12.5228 11.4622L6.52279 5.62924L5.47721 6.70476L11.4772 12.5378L12.5228 11.4622Z" fill="#f8f8f8" />
                </svg>
              </div>
            }
            <div className="mb-4 px-4 h-max ">
              <ul className="w-full flex flex-col justify-start space-y-3">
                {!isMore && menus.map((barmenu: any, index1: any) => {
                  return <li
                    className={`flex items-center h-10 ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} ${index1 > 8 ? 'hidden' : ""} `}
                    onClick={() => handleMenu(index1, null)} >
                    <div className={`flex flex-row justify-start  rounded-lg  px-4  cursor-pointer  h-10 items-center hover:bg-secondary  max-w-24   dark:hover:text-black"`}>
                      {barmenu?.svg}
                    </div>
                    <ul className={`flex flex-col space-y-3 items-center  max-h-[300px] max-w-56 overflow-auto justify-start  py-5 px-3  primary-${color} ml-0 ${index1 > 4 ? "mt-[calc(100vh-60rem)]" : "mt-auto"} rounded-r-xl min-w-64  font-medium text-sm  "  ${open[index1]?.open ? 'hidden' : 'ml-4'}`}>
                      {barmenu?.subMenu?.map((obj1: any, index2: any) => {
                        return <ul
                          onClick={(e) => handleSubMenu(e, index2)}
                          className={`w-full flex pl-2 flex-col  justify-center space-y-3 ${open[index1]?.open ? 'hidden' : 'pl-2'} `}>
                          <div className={`flex flex-row justify-start  items-center  rounded-r-lg  px-2 cursor-pointer  h-10 hover:bg-secondary dark:hover:text-black"  ${subOpen[index2]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                            {obj1?.svg}
                            <div onClick={() => handleNavigate(obj1?.path)} className="primary-${color}  text-sm dark:text-slate-200 dark:hover:text-black   flex flex-col w-auto justify-center items-end">
                              <span className="">{beginWord(obj1.label)}</span>
                              <span className="text-right text-xs italic">{endWord(obj1.label)}</span>
                            </div>
                          </div>
                          {obj1?.subMenu?.map((obj2: any, index3: any) => {
                            return <li
                              onClick={(e) => handleItems(e, index3)}
                              className={`w-full flex flex-col pl-2 justify-start space-y-3  ${subOpen[index2]?.open ? 'hidden' : 'ml-2'} `}>
                              <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary dark:hover:text-black"  ${menuOpen[index3]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                                {obj2?.svg}
                                <div onClick={() => handleNavigate(obj2?.path)} className="text-sm dark:text-slate-200 dark:hover:text-black w-36 flex flex-col w-auto justify-center items-end">
  
                                  <span className="">{beginWord(obj2.label)}</span>
                                  <span className="text-right text-xs italic"> {endWord(obj2.label)}</span>
                                </div>
                              </div>
                            </li>
                          })}
                        </ul>
                      })}
                    </ul>
                  </li>
                })}
                {isMore && menus.map((barmenu: any, index1: any) => {
                  return <li
                    className={`flex items-center h-10 ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} ${index1 < 8 ? 'hidden' : ""} `}
                    onClick={() => handleMenu(index1, null)} >
                    <div className={`flex flex-row justify-start  rounded-lg  px-4  cursor-pointer  h-10 items-center hover:bg-secondary  max-w-24   dark:hover:text-black"`}>
                      {barmenu?.svg}
                    </div>
                    <ul className={`flex flex-col space-y-3 items-center  max-h-[300px] max-w-56 overflow-auto justify-start  py-5 px-3  bg-primary dark:bg-slate-800 ml-0 ${index1 > 12 ? "mt-[calc(100vh-60rem)]" : "mt-auto"} rounded-r-xl min-w-64  font-medium text-sm  "  ${open[index1]?.open ? 'hidden' : 'ml-4'}`}>
                      {barmenu?.subMenu?.map((obj1: any, index2: any) => {
                        return <ul
                          onClick={(e) => handleSubMenu(e, index2)}
                          className={`w-full flex pl-2 flex-col  justify-center space-y-3 ${open[index1]?.open ? 'hidden' : 'pl-2'} `}>
                          <div className={`flex flex-row justify-start  items-center  rounded-r-lg  px-2 cursor-pointer  h-10 hover:bg-secondary dark:hover:text-black"  ${subOpen[index2]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                            {obj1?.svg}
                            <div onClick={() => handleNavigate(obj1?.path)} className="primary-${color} text-sm dark:text-slate-200 dark:hover:text-black   flex flex-col w-auto justify-center items-end">
                              <span className="">{beginWord(obj1.label)}</span>
                              <span className="text-right text-xs italic">{endWord(obj1.label)}</span>
                            </div>
                          </div>
                          {obj1?.subMenu?.map((obj2: any, index3: any) => {
                            return <li
                              onClick={(e) => handleItems(e, index3)}
                              className={`w-full flex flex-col pl-2 justify-start space-y-3  ${subOpen[index2]?.open ? 'hidden' : 'ml-2'} `}>
                              <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary dark:hover:text-black"  ${menuOpen[index3]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                                {obj2?.svg}
                                <div onClick={() => handleNavigate(obj2?.path)} className="text-sm dark:text-slate-200 dark:hover:text-black w-36 flex flex-col w-auto justify-center items-end">
                                  <span className="">{beginWord(obj2.label)}</span>
                                  <span className="text-right text-xs italic"> {endWord(obj2.label)}</span>
                                </div>
                              </div>
                            </li>
                          })}
                        </ul>
                      })}
                    </ul>
                  </li>
                })}
              </ul>
            </div>
          </div>
          {/* <div
            onClick={() => setIsMore(!isMore)}
            className="w-24 text-xs text-right px-4 text-blue-500 underline cursor-pointer">
            {!isMore ? 'More' : 'Less'}
          </div> */}
        </div>}
      </>
    )
  }
  
  export default Sidebar;